// Mirrored verbatim from NOX dashboard (src/components/ui/spinner.tsx).
export function Spinner() {
  return (
    <div className="flex items-center justify-center w-full py-8">
      <div className="h-7 w-7 rounded-full border-2 border-white/10 animate-spin" style={{ borderTopColor: "#c57eff" }} />
    </div>
  );
}

// Compact inline spinner for inside buttons / rows.
export function InlineSpinner({ size = 14 }: { size?: number }) {
  return (
    <span
      className="inline-block rounded-full border-2 border-white/10 animate-spin align-middle"
      style={{ width: size, height: size, borderTopColor: "#c57eff" }}
    />
  );
}
